var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-text-field",
    _vm._b(
      {
        attrs: {
          type: "time",
          "prepend-icon": "access_time",
          label: _vm.label,
          value: _vm.formattedValue,
          "data-vv-name": _vm.id,
          "data-testid": _vm.testId
        },
        on: { input: _vm.handleChange }
      },
      "v-text-field",
      Object.assign({}, _vm.$props, _vm.$attrs),
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }